import * as React from 'react';
import WorkcalendarListDesktop from './WorkcalendarListDesktop';

const WorkcalendarListMobile = () => {

    return (<WorkcalendarListDesktop/>)
}

export default WorkcalendarListMobile